import { render, staticRenderFns } from "./FlightCardDetails.vue?vue&type=template&id=647538b0&scoped=true"
import script from "./FlightCardDetails.vue?vue&type=script&lang=js"
export * from "./FlightCardDetails.vue?vue&type=script&lang=js"
import style0 from "./FlightCardDetails.vue?vue&type=style&index=0&id=647538b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "647538b0",
  null
  
)

export default component.exports